import { useEffect } from "react";
import { Container } from "react-bootstrap";
import PriceList from "@/components/service/components/price-list/PriceList";
import InfoList from "@/components/service/components/info-list/InfoList";
import ScrollAnimation from "@/components/home/scroll-animation/ScrollAnimation";
import priceList from "@/data/holideals/price-list.json";
import infoList from "@/data/holideals/info-list.json";
import PageSEO from "@/components/common/PageSEO";

const HoliDeals = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <PageSEO section="summerdeals" />
      <ScrollAnimation />
      <Container style={{ height: "100%" }}>
        <PriceList data={priceList} />
        <InfoList data={infoList} />
      </Container>
    </>
  );
};

export default HoliDeals;
